export enum HttpMethods {
  POST,
  PUT,
  GET,
  DELETE
}
